// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2I3QY","errors":"Errors_errors__Mi8mQ"};